/**
 * @ngdoc service
 * @name proximus.core.platform.service:platformService
 * @description
 * # PlatformService
 *  detects mobile device
 */
/* istanbul ignore next */
export default class PlatformService {
    // Based on https://github.com/facebook/react-native/commit/3c65e62183ce05893be0822da217cb803b121c61
    isReactNative() {
        return (navigator === null || navigator === void 0 ? void 0 : navigator.product) === 'ReactNative';
    }
    isMagnoliaAuthor() {
        const hostName = window.location.hostname;
        return ![
            'author-itt.proximus.be',
            'ecmj6i1.web.bc',
            'author-uat.proximus.be',
            'ecmj6a1.web.bc',
            'author-dr.proximus.be',
            'ecmj6b1.web.bc',
            'author.proximus.be',
            'ecmj6p1.web.bc',
        ].every(authorHostname => hostName.indexOf(authorHostname) === -1);
    }
}
